var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-review", class: _vm.classNames }, [
    !_vm.formIsOpened && !_vm.status
      ? _c(
          "div",
          { staticClass: "add-review__header" },
          [
            _vm._t("default"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-main btn-block",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleForm(true)
                  }
                }
              },
              [_vm._v("Добавить отзыв\n        ")]
            )
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "add-review__content" },
      [
        _vm.formIsOpened
          ? [
              _c("add-review-form", {
                attrs: { product: _vm.productId },
                on: {
                  close: function($event) {
                    return _vm.toggleForm(false)
                  },
                  send: _vm.onSend
                }
              })
            ]
          : _vm._e(),
        _vm._v(" "),
        this.status
          ? [
              _c("add-review-notification", {
                attrs: { response: this.status },
                on: { close: _vm.hideNotification }
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }